import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import Prismic from 'prismic-javascript'
import groupBy from 'lodash/groupBy'
import map from 'lodash/map'

import Page from '../../components/Page'

import './style.css'

const apiEndpoint = 'https://buda-vet.cdn.prismic.io/api/v2'
const MAX_PAGE_SIZE = 100

class Prices extends Component {
  state = {
    prices: [],
  }
  async componentDidMount() {
    const api = await Prismic.getApi(apiEndpoint)

    const createQuery = typeName => [
      Prismic.Predicates.at('document.type', typeName),
      { pageSize: MAX_PAGE_SIZE },
    ]
    api.query(...createQuery('arlista')).then(apiResult => {
      const prices = groupBy(apiResult.results[0].data.sor, 'kategoria')
      this.setState({ prices })
    })
  }

  render() {
    return (
      <Page title="Áraink" noHero>
        <div className="sectionTitle">Áraink</div>
        <Grid className="Prices">
          <Row center="xs">
            <Col md={8} xs={12}>
              {map(this.state.prices, (category, categoryName) => (
                <div key={categoryName}>
                  <Row className="priceEntry category">
                    <Col xs={12}>{categoryName}</Col>
                  </Row>
                  {category.map((price, i) => (
                    <Row className="priceEntry" key={i}>
                      <Col xs={6}>
                        <div className="title">{price.nev}</div>
                        <div className="detail">{price.leiras}</div>
                      </Col>
                      <Col xs={6}>
                        <div className="price">{price.ar}</div>
                      </Col>
                    </Row>
                  ))}
                </div>
              ))}
            </Col>
          </Row>
        </Grid>
      </Page>
    )
  }
}

export default Prices



// WEBPACK FOOTER //
// ./src/pages/Prices/index.js